import { isPlatformBrowser } from '@angular/common';
import { ErrorHandler, inject, Injectable, PLATFORM_ID } from '@angular/core';

const CHUNK_LOAD_ERROR =
    /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module/i;
const RELOAD_FLAG = 'chunkReloadAt';
// Evita bucles: como mucho una recarga automática por minuto
const RELOAD_COOLDOWN_MS = 60_000;

/**
 * Tras un despliegue, una pestaña abierta (o un main.js cacheado) puede pedir
 * chunks que ya no existen en el servidor. En ese caso recargamos la página una
 * vez para coger la versión nueva en lugar de dejarla a medio pintar.
 */
@Injectable()
export class ChunkLoadErrorHandler extends ErrorHandler {
    private readonly platformId = inject(PLATFORM_ID);

    override handleError(error: unknown): void {
        if (isPlatformBrowser(this.platformId) && this.isChunkLoadError(error)) {
            if (this.reloadAllowed()) {
                window.location.reload();
                return;
            }
        }
        super.handleError(error);
    }

    private isChunkLoadError(error: unknown): boolean {
        const message =
            (error as { message?: string })?.message ??
            (error as { rejection?: { message?: string } })?.rejection?.message ??
            String(error);
        return CHUNK_LOAD_ERROR.test(message);
    }

    private reloadAllowed(): boolean {
        try {
            const last = Number(sessionStorage.getItem(RELOAD_FLAG) ?? 0);
            if (Date.now() - last < RELOAD_COOLDOWN_MS) return false;
            sessionStorage.setItem(RELOAD_FLAG, String(Date.now()));
            return true;
        } catch {
            return false;
        }
    }
}
